// Remembers the last full path visited for a given named route, so navigation
// that switches between routes (e.g. PageSwitch) can restore exactly where the
// user left off instead of navigating to a bare, param-less path.
const lastPathByRouteName = {};

export const rememberPath = (routeName, fullPath) => {
  lastPathByRouteName[routeName] = fullPath;
};

export const getLastPathForRoute = (routeName) => lastPathByRouteName[routeName];
